// extracted by css-extract-rspack-plugin
export default {"cls1":"SignUpButton-cls1_jzU","cls2":"SignUpButton-cls2_eC3 SignUpButton-cls1_jzU","small":"SignUpButton-small_etw"};